import { render, staticRenderFns } from "./tripTable.vue?vue&type=template&id=0b651d9f"
import script from "./tripTable.vue?vue&type=script&lang=js"
export * from "./tripTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports